const settings = {
  brandSite: true,
  channels: [
    {
      channel: 'Gammeldansk DK',
      locale: 'da-DK',
      languageCode: 'da',
      slugs: {
        ContentfulArticlePage: 'artiklar',
      },
    },
    {
      channel: 'Gammeldansk EN',
      locale: 'en-US',
      languageCode: 'en',
      slugs: {
        ContentfulArticlePage: 'articles',
      },
    },
  ],
  localization: {
    default: 'da-DK',
    defaultLanguageCode: 'da',
  },
};

export default settings;
